<mat-dialog-content class="customer-dialog">
  <!-- <section class="w3l-hero-headers-11 p-sticky-md">
      <div class="top-header">
          <div class="d-grid grid-columns-top-3">
              <div class="accounts">
                  <ul>
                      <li></li>
                      <li></li>
                  </ul>
              </div>
              <div class="search">
                  <form action="search-results.html" method="get">
                      <input id="search" name="search" type="text" [(ngModel)]="supCode"
                          (change)="retriveSuppliesLookup()" placeholder="Supplier Code">
                      <input id="search" name="search" type="text" [(ngModel)]="supName"
                          (change)="retriveSuppliesLookup()" placeholder="Supplier Name">

                  </form>
              </div>
          </div>
      </div>
  </section> -->
<div class="search-container">
    <mat-form-field >
      <mat-label>Supplier Code</mat-label>
      <input matInput [(ngModel)]="supCode" (keyup)="retriveSuppliesLookup()">
    </mat-form-field>

    <mat-form-field  >
      <mat-label>Supplier Name</mat-label>
      <input matInput [(ngModel)]="supName" (keyup)="retriveSuppliesLookup()">
    </mat-form-field>

  </div>



  <!-- <table>
      <thead>
          <tr>
              <th style="width: 20%;">Supplier ID</th>
              <th style="width: 130%;">Supplier Name</th>
              <th style="width: 30%;">Choose</th>
          </tr>
      </thead>
      <tbody>
          <tr *ngFor="let Sup of suppliesList; let i = index">
              <td data-column="Supplies ID">{{Sup.supCode}}</td>
              <td data-column="Supplier Name">{{Sup.supName}}</td>
              <td data-column="Choose"><button type="button" class="theme-button btn" (click)="SelectSupp(Sup)" name="submit">Select</button>
              </td>
          </tr>
      </tbody>
  </table> -->
<div class="table-container">
    <table class="customer-table">
      <thead>
        <tr matTooltip="Click for sorting" style="cursor: ns-resize;">
        <th style="width: 30%;">Supplier ID</th>
        <th style="width: 100%;">Supplier Name</th>
        <th style="width: 20%;">Choose</th>
        </tr>

      </thead>
      <tbody>
        <tr *ngFor="let Sup of suppliesList; let i = index">
        <td>{{Sup.supCode}}</td>
        <td>{{Sup.supName}}</td>
          <td>
            <button mat-raised-button style="color: white;background-color: rgb(0, 0, 128);"
                    (click)="SelectSupp(Sup)">{{'Select' | translate}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</mat-dialog-content>
